// sessionStorage-based app context management
// app_id, app_title, app_name are stored per-tab to allow multiple apps in different tabs

export const AppStorageKey = {
  AppId: 'app_id',
  AppTitle: 'app_title',
  AppName: 'app_name',
  AppDescription: 'app_description',
  LrSubdir: 'lr_subdir',
};

export const appStorage = {
  getAppId() {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(AppStorageKey.AppId) || null;
  },

  setAppId(value) {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem(AppStorageKey.AppId, value);
  },

  getAppTitle() {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(AppStorageKey.AppTitle) || null;
  },

  setAppTitle(value) {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem(AppStorageKey.AppTitle, value);
  },

  getAppName() {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(AppStorageKey.AppName) || null;
  },

  setAppName(value) {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem(AppStorageKey.AppName, value);
  },

  getAppDescription() {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(AppStorageKey.AppDescription) || null;
  },

  setAppDescription(value) {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem(AppStorageKey.AppDescription, value);
  },

  getLrSubdir() {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(AppStorageKey.LrSubdir) || null;
  },

  setLrSubdir(value) {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem(AppStorageKey.LrSubdir, value);
  },

  clear() {
    if (typeof window === 'undefined') return;
    sessionStorage.removeItem(AppStorageKey.AppId);
    sessionStorage.removeItem(AppStorageKey.AppTitle);
    sessionStorage.removeItem(AppStorageKey.AppName);
    sessionStorage.removeItem(AppStorageKey.AppDescription);
    sessionStorage.removeItem(AppStorageKey.LrSubdir);
  },
};
